import { render, staticRenderFns } from "./NewReferral.vue?vue&type=template&id=37ee7e54&scoped=true&"
import script from "./NewReferral.vue?vue&type=script&lang=js&"
export * from "./NewReferral.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37ee7e54",
  null
  
)

export default component.exports